import PropTypes from "prop-types"
import { FormControl, FormHelperText, InputLabel, NativeSelect, OutlinedInput, Select } from "@mui/material"

const DropdownCommon = ({
  disabled,
  error,
  label,
  multiple,
  native,
  name,
  onChange,
  renderOptions,
  required,
  value,
  ...rest
}) => {
  const labelId = `${name}-label`
  const selectId = `${name}-select`
  const helperId = `${name}-helper-text`

  return (
    <FormControl disabled={disabled} error={!!error} fullWidth size="small">
      <InputLabel id={labelId} required={required}>
        {label}
      </InputLabel>

      {native ? (
        <NativeSelect
          {...rest}
          id={selectId}
          inputProps={{
            ...((rest.inputProps || {})),
            'data-field': name,
            'data-testid': selectId,
            id: selectId,
            name,
          }}
          inputRef={rest.inputRef}
          name={name}
          onChange={onChange}
          required={required}
          value={value ?? ""}
        >
          {renderOptions}
        </NativeSelect>
      ) : (
        <Select
          {...rest}
          aria-describedby={helperId}
          aria-label={label}
          data-field={name}
          data-testid={selectId}
          error={!!error}
          id={selectId}
          input={<OutlinedInput label={label} />}
          label={label}
          labelId={labelId}
          MenuProps={{ disablePortal: true, disableScrollLock: true }}
          multiple={!!multiple}
          name={name}
          onChange={onChange}
          required={required}
          SelectDisplayProps={{
            ...((rest.SelectDisplayProps || {})),
            'data-field': name,
            'data-testid': `${name}-trigger`,
          }}
          value={value ?? (multiple ? [] : "")}
        >
          {renderOptions}
        </Select>
      )}

      <FormHelperText className={name} id={helperId}>
        {error?.message || ""}
      </FormHelperText>
    </FormControl>
  )
}

DropdownCommon.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.object,
  label: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  native: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  renderOptions: PropTypes.array.isRequired,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string
  ])
}

export default DropdownCommon